import { Routes } from '@models/route';
import { AccessDeniedErrorPage } from '@pages/error/AccessDeniedErrorPage';
import { lazy } from 'react';

const ErrorPage = lazy(() =>
  import('@pages/error/SuspendedErrorPage').then((p) => ({ default: p.SuspendedErrorPage }))
);

const DeviceErrorPage = lazy(() =>
  import('@pages/error/DeviceErrorPage').then((p) => ({ default: p.DeviceErrorPage }))
);

export const ErrorRoutes: Routes = [
  {
    path: 'error_page',
    component: ErrorPage
  },
  {
    path: 'access_denied',
    component: AccessDeniedErrorPage
  },
  {
    path: 'device_denied',
    component: DeviceErrorPage
  }
];
